import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../redux/configureStore';
import { setSituation } from '../../../../../../../../../redux/fetchActions/legadoPage/transferApp';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';
import { TpRetorno } from '../../../../../../../../../utils/businessRule';

function SetSituacao() {
  const dispatch = useDispatch();
  const transfersFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );

  function set(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setSituation(value));
  }

  const situationArr = Object.entries(TpRetorno);
  return (
    <Wrapper.Default
      width="35%"
      style={{ padding: '0 5px 5px' }}
      isActive
      flexDirection="row"
      alignItens="start">
      <span style={{ fontWeight: 700, lineHeight: '34px', minWidth: '100px' }}>
        Situação:
      </span>
      <Form.Control
        as="select"
        value={transfersFilterState.status}
        onChange={(event) => set(event)}>
        {situationArr.map((item, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <option key={index} value={item[1]}>
              {item[0]}
            </option>
          );
        })}
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetSituacao;
